/**
 * Pins Ask AI 1rem above the uppermost visible bottom-fixed bar below
 * 1150px (where the mobile toolbar can show). At 1150px and up the widget
 * stays at the CSS bottom of 1rem. Recalculates only when size, visibility,
 * or layout changes — not on scroll.
 */
(function () {
  var widget = document.querySelector("[data-ask-ai]");
  if (!widget) return;

  var DESKTOP_MQ = window.matchMedia("(min-width: 1150px)");
  var SELECTORS = [
    ".new-toolbar-mobile",
    ".hdt-section-toolbar-mobile .hdt-toolbar",
    ".hdt-toolbar-mobile .hdt-toolbar",
    ".cart-progressBar",
    ".hdt-sticky-btn-atc",
    ".hdt-product-info__item.hdt-product__buy-button",
  ];

  var observed = new WeakSet();
  var resizeObserver = null;
  var attrObserver = null;
  var stickyLatched = false;
  var stickyReleaseTimer = 0;
  var scheduled = false;
  var lastBottom = "";

  if (typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(schedule);
  }
  if (typeof MutationObserver !== "undefined") {
    attrObserver = new MutationObserver(schedule);
  }

  function gapPx() {
    var root = parseFloat(getComputedStyle(document.documentElement).fontSize);
    return root > 0 ? root : 16;
  }

  function translateY(transform) {
    if (!transform || transform === "none") return 0;
    var raw;
    if (transform.indexOf("matrix3d(") === 0) {
      raw = transform.slice(9, -1).split(",");
      return parseFloat(raw[13]) || 0;
    }
    if (transform.indexOf("matrix(") === 0) {
      raw = transform.slice(7, -1).split(",");
      return parseFloat(raw[5]) || 0;
    }
    return 0;
  }

  function isHidden(el, style) {
    if (!el || el.hidden) return true;
    if (style.display === "none" || style.visibility === "hidden") return true;
    if (parseFloat(style.opacity) === 0) return true;
    if (el.offsetHeight < 1 || el.offsetWidth < 1) return true;
    return false;
  }

  function offersTabExtra(el) {
    if (!el.classList || !el.classList.contains("cart-progressBar")) return 0;
    var tab = el.querySelector(".cart-progressBar__offers-tab, [data-ctx-offers-tab]");
    if (!tab || tab.hidden) return 0;
    var tabStyle = getComputedStyle(tab);
    if (isHidden(tab, tabStyle)) return 0;
    return tab.offsetHeight || 0;
  }

  function stickyIsOpen(el) {
    if (el.classList.contains("hdt-always-sticky-btn-atc-on-mobile")) return true;
    if (document.body.classList.contains("sticky-shown")) return true;
    return stickyLatched;
  }

  /**
   * Distance from the layout viewport bottom to the visual top of a bottom bar.
   * Uses CSS bottom + border-box height so iOS address-bar changes stay in the
   * same coordinate space as position:fixed.
   */
  function clearance(el) {
    var style = getComputedStyle(el);
    if (isHidden(el, style)) return 0;
    if (style.position !== "fixed" && style.position !== "sticky") return 0;

    var shift = translateY(style.transform);
    if (el.classList.contains("hdt-sticky-btn-atc")) {
      if (!stickyIsOpen(el) && shift > el.offsetHeight * 0.6) return 0;
    } else if (shift > el.offsetHeight * 0.6) {
      return 0;
    }

    var bottom = parseFloat(style.bottom);
    var marginBottom = parseFloat(style.marginBottom) || 0;
    if (!isFinite(bottom)) {
      var rect = el.getBoundingClientRect();
      return Math.max(0, Math.ceil(window.innerHeight - rect.top));
    }
    return Math.ceil(bottom + marginBottom + el.offsetHeight + offersTabExtra(el));
  }

  function watch(el) {
    if (!el || observed.has(el)) return;
    observed.add(el);
    if (resizeObserver) resizeObserver.observe(el);
    el.addEventListener("transitionend", onTransitionEnd);
    if (attrObserver) {
      attrObserver.observe(el, {
        attributes: true,
        attributeFilter: ["class", "style", "hidden", "aria-hidden"],
      });
    }
    if (el.classList.contains("cart-progressBar")) {
      var tab = el.querySelector(".cart-progressBar__offers-tab, [data-ctx-offers-tab]");
      if (tab) watch(tab);
    }
  }

  function onTransitionEnd(event) {
    if (event.propertyName && event.propertyName !== "transform") return;
    var sticky = event.currentTarget;
    if (!sticky.classList || !sticky.classList.contains("hdt-sticky-btn-atc")) {
      schedule();
      return;
    }
    if (
      !document.body.classList.contains("sticky-shown") &&
      !sticky.classList.contains("hdt-always-sticky-btn-atc-on-mobile")
    ) {
      stickyLatched = false;
    }
    schedule();
  }

  function syncStickyLatch() {
    var sticky = document.querySelector(".hdt-sticky-btn-atc");
    var open =
      document.body.classList.contains("sticky-shown") ||
      (sticky && sticky.classList.contains("hdt-always-sticky-btn-atc-on-mobile"));
    if (open) {
      stickyLatched = true;
      if (stickyReleaseTimer) {
        clearTimeout(stickyReleaseTimer);
        stickyReleaseTimer = 0;
      }
      return;
    }
    if (!stickyLatched) return;
    if (stickyReleaseTimer) return;
    stickyReleaseTimer = window.setTimeout(function () {
      stickyReleaseTimer = 0;
      stickyLatched = false;
      schedule();
    }, 550);
  }

  function update() {
    scheduled = false;
    if (DESKTOP_MQ.matches) {
      if (lastBottom !== "") {
        widget.style.removeProperty("bottom");
        lastBottom = "";
      }
      markReady();
      return;
    }

    var nodes = document.querySelectorAll(SELECTORS.join(","));
    var stack = 0;
    for (var i = 0; i < nodes.length; i++) {
      watch(nodes[i]);
      var next = clearance(nodes[i]);
      if (next > stack) stack = next;
    }

    var bottom = stack > 0 ? Math.round(stack + gapPx()) + "px" : "";
    if (bottom !== lastBottom) {
      if (bottom) widget.style.bottom = bottom;
      else widget.style.removeProperty("bottom");
      lastBottom = bottom;
    }
    markReady();
  }

  function markReady() {
    if (!widget.hasAttribute("data-ask-ai-ready")) {
      widget.setAttribute("data-ask-ai-ready", "");
    }
  }

  function schedule() {
    syncStickyLatch();
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  }

  schedule();
  window.addEventListener("resize", schedule, { passive: true });
  window.addEventListener("orientationchange", schedule, { passive: true });
  window.addEventListener("load", schedule, { once: true });

  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", schedule, { passive: true });
  }

  if (typeof DESKTOP_MQ.addEventListener === "function") {
    DESKTOP_MQ.addEventListener("change", schedule);
  } else if (typeof DESKTOP_MQ.addListener === "function") {
    DESKTOP_MQ.addListener(schedule);
  }

  if (attrObserver) {
    attrObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["style", "class"],
    });
    attrObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class", "style"],
    });
  }

  document.addEventListener("shopify:section:load", schedule);
})();
